import {
  CONFIRMED_GET_PATHYA,
  CONFIRMED_CREATE_PATHYA,
  CONFIRMED_EDIT_PATHYA,
  CONFIRMED_DELETE_PATHYA,
} from "../types/PathyaTypes";

const initialState = {
  list: [],
  num_rows: 0,
};

const PathyaReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRMED_GET_PATHYA:
      return {
        ...state,
        list: action.payload.list || [],
        num_rows: action.payload.num_rows || 0,
      };
    
    case CONFIRMED_CREATE_PATHYA:
      return {
        ...state,
        list: [action.payload, ...state.list],
      };

      case CONFIRMED_EDIT_PATHYA:
        return {
          ...state,
          list: state.list.map((item) =>
            item.pathya_id === action.payload.pathya_id
              ? action.payload
              : item
          ),
        };
      
        case CONFIRMED_DELETE_PATHYA:
          return {
            ...state,
            list: state.list.filter(
              (item) => item.pathya_id !== action.payload.pathya_id
            ),
          };
        
  
    default:
      return state;
  }
};

export default PathyaReducer;
